import { render, staticRenderFns } from "./WheelsetBasedata.vue?vue&type=template&id=ed14787e&scoped=true"
import script from "./WheelsetBasedata.vue?vue&type=script&lang=js"
export * from "./WheelsetBasedata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed14787e",
  null
  
)

export default component.exports